import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card__head d-flex align-items-center" }
const _hoisted_2 = { class: "d-flex align-items-center icon-text ml-2" }
const _hoisted_3 = { class: "bt-icon my-auto bt-icon--m" }
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { class: "mt-1 mb-0" }
const _hoisted_6 = { class: "my-0 text-gray" }
const _hoisted_7 = { class: "btn-stripped" }
const _hoisted_8 = { class: "btn-stripped text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_Card = _resolveComponent("Card")
  const _component_DialogConfirmDelete = _resolveComponent("DialogConfirmDelete")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, {
      class: ["message-card card--slim", {'message-expired': _ctx.expired}]
    }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_InlineSvgScoped, {
                src: 
                                require(`@/assets/images/entrancePlants/icon-message.svg`)
                            ,
                "aria-label": "icon-message"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode("h6", _hoisted_5, _toDisplayString(_ctx.message.title), 1),
              _createVNode("small", _hoisted_6, _toDisplayString(_ctx.gates) + ": " + _toDisplayString(_ctx.getValidTime()), 1)
            ])
          ]),
          (!_ctx.offline)
            ? (_openBlock(), _createBlock(_component_ElDropdown, {
                key: 0,
                class: "ml-auto my-auto p-button-text",
                trigger: "click",
                placement: "bottom-end",
                "popper-class": "el-dropdown__popper el-dropdown--context"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ElDropdownItem, { onClick: _ctx.handleEditMessage }, {
                        default: _withCtx(() => [
                          _createVNode("button", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_ElDropdownItem, { onClick: _ctx.toggleDeleteMessageConfirm }, {
                        default: _withCtx(() => [
                          _createVNode("button", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: _ctx.$t('AppResource.More'),
                    class: "ml-auto p-button-text"
                  }, null, 8, ["label"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_DialogConfirmDelete, {
      "is-visible": _ctx.isVisibleDeleteMessageConfirm,
      title: _ctx.$t('AppResourceEP.GateMessageDeletionPopupTitle'),
      message: _ctx.$t('AppResourceEP.GateMessageDeletionPopupMessage'),
      onHideDialog: _ctx.toggleDeleteMessageConfirm,
      onConfirm: _ctx.handleDeleteMessage
    }, null, 8, ["is-visible", "title", "message", "onHideDialog", "onConfirm"])
  ], 64))
}